// Point initial = partie du nom, pas séparateur : `.env` n'a pas d'extension.
export function getFileExtension(filename) {
	if (typeof filename !== "string") return null

	const lastDot = filename.lastIndexOf(".")

	if (lastDot <= 0 || lastDot === filename.length - 1) return null

	return filename.slice(lastDot + 1).toLowerCase()
}

export function getFileNameNoExt(filename) {
	const ext = getFileExtension(filename)
	if (ext) {
		// Coupé sur le nom source : `toLowerCase` peut rallonger l'extension (`İ`).
		return filename.slice(0, filename.lastIndexOf("."))
	} else {
		return filename
	}
}

export function buildRenamedFileName(originalName, newName) {
	const ext = getFileExtension(originalName)
	return ext ? `${newName}.${ext}` : newName
}
